
interface Props {
  message?: string;
  children?: React.ReactNode;
}

export default function ErrorAlert({ message, children }: Props) {
  return (
    <div role="alert" className="rounded-xl border border-red-100 bg-red-50/80 p-4">
      {children ?? <p className="text-sm text-red-700">{message}</p>}
    </div>
  );
}
